const SvgPolyIcon = () => {
  return (
    <svg
      width="8"
      height="7"
      viewBox="0 0 8 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="cartitem-units-menu-title-icon"
        d="M3.48886 0.883864C3.88249 0.271541 4.77758 0.271541 5.17121 0.883864L7.83955 5.03461C8.26738 5.70012 7.78954 6.57536 6.99837 6.57536L1.6617 6.57536C0.870534 6.57536 0.392693 5.70012 0.820522 5.03461L3.48886 0.883864Z"
      />
    </svg>
  );
};

export default SvgPolyIcon;
